import {
  API_ADMIN_ACCOUNTING_BANK_DIRECTORY,
  API_ADMIN_ACCOUNTING_BANK_DIRECTORY_IMPORT,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_BACKFILL,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_BY_ID,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_ENTRY,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_ENTRY_BY_ID,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_LEDGER,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_OPTIONS,
  API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_TRANSFER,
  API_ADMIN_ACCOUNTING_TRUST_LEDGER_PARTY,
  API_TRUST_ACCOUNT_ASSIGNMENT,
} from 'config'
import Api from 'services/api'

export const getTrustAccounts = (filters: Record<string, any> = {}) => {
  return Api.get(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT, filters)
}

/** Accounts a picker can offer, optionally narrowed to one purpose. */
export const getTrustAccountOptions = (purpose = '') => {
  return Api.get(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_OPTIONS, purpose ? { purpose } : {})
}

export const createTrustAccount = (data: Record<string, any>) => {
  return Api.post(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT, data)
}

export const updateTrustAccount = (id: number, data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_BY_ID, data, { id })
}

/** Deactivates instead of deleting once money has moved through the account. */
export const deleteTrustAccount = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_BY_ID, {}, { id })
}

export const getTrustAccountLedger = (id: number, filters: Record<string, any> = {}) => {
  return Api.get(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_LEDGER, filters, { id })
}

/** A lender's or vendor's trust ledger. `partyType` is `Lender` or `Vendor`. */
export const getPartyTrustLedger = (partyType: string, partyId: number, filters: Record<string, any> = {}) => {
  return Api.get(API_ADMIN_ACCOUNTING_TRUST_LEDGER_PARTY, filters, { partyType, partyId })
}

export const createTrustAccountEntry = (data: Record<string, any>) => {
  return Api.post(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_ENTRY, data)
}

export const updateTrustAccountEntry = (id: number, data: Record<string, any>) => {
  return Api.put(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_ENTRY_BY_ID, data, { id })
}

export const deleteTrustAccountEntry = (id: number) => {
  return Api.delete(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_ENTRY_BY_ID, {}, { id })
}

export const transferBetweenTrustAccounts = (data: Record<string, any>) => {
  return Api.post(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_TRANSFER, data)
}

/** Stamps the account onto ledger rows written before trust accounts existed. */
export const backfillTrustAccountLedgerRows = (data: { dryRun?: boolean; loanNumber?: number } = {}) => {
  return Api.post(API_ADMIN_ACCOUNTING_TRUST_ACCOUNT_BACKFILL, data)
}

/** The open loan's three trust accounts, and how each was resolved. */
export const getLoanTrustAccountAssignment = () => {
  return Api.get(API_TRUST_ACCOUNT_ASSIGNMENT)
}

export const setLoanTrustAccountAssignment = (purpose: string, trustAccountId: number | null) => {
  return Api.put(API_TRUST_ACCOUNT_ASSIGNMENT, { purpose, trustAccountId })
}

/** How many routing numbers the bank-name auto-fill can resolve today. */
export const getBankDirectoryCount = (): Promise<{ count: number }> => {
  return Api.get(API_ADMIN_ACCOUNTING_BANK_DIRECTORY)
}

/** Load the FedACH participant file, or a `routingNumber,bankName[,city,state]` CSV. */
export const importBankDirectory = (content: string): Promise<{ imported: number; skipped: number }> => {
  return Api.post(API_ADMIN_ACCOUNTING_BANK_DIRECTORY_IMPORT, { content })
}
